<script>
    import {
    link
  } from "svelte-routing";
</script>
<footer class='bd-footer py-4 py-md-5' id='footer'>
  <div class='container py-4 py-md-5 px-4 px-md-3'>
      <div class='row'>
          <div class='col-lg-3 col-md'>
              <img class='w-100 w-sm-50'
              src="/components_dash/dist/img/ratingg_logo.svg"
              alt="ratting logo"
              width='auto' />
              <p class='pt-1 fs-6'>El sistema <b>ratingg</b> para evaluación de servicio de empresas del sector restaurantero está basado en el mundialmente reconocido instrumento Dinerserv. </p>
          </div>
          <div class='col-lg-3 col-md'>
              <p class='pt-1 fs-5'> Contacto: </p>
              <p class='fs-6'> <a href="mailto:sistemas.programacion@eltecon.com.mx
                ">sistemas.programacion@eltecon.com.mx
            </a> </p>
            <a use:link href="/politicas" >Nuestras politicas de privacidad.</a> 
          </div>
          <div class="col-lg-3 col-md" >
            
        </div>
          
      </div>
      
  </div>
 
</footer>

<style>
  #footer{
      min-height: 25%;
      color: rgb(237, 248, 234);
      background-color: rgb(76, 76, 60);
  }
  a:link { 
      color: rgb(237, 248, 234);
background-color: transparent;
text-decoration: none;
}

a:visited {
      color: rgb(237, 248, 234);
background-color: transparent;
text-decoration: none;
}
</style>